import { SaleOfferBearingVisibility } from './sale-offer-bearing-visibility';

export class SaleOfferBearing {
  constructor(
    public hash?: string,
    public saleOfferHash?: string,
    public bearingDate?: number,
    public observations?: string,
    public loadingCustomerHash?: string,
    public loadingCustomerBusinessName?: string,
    public loadingCustomerNif?: string,
    public loadingPlace?: string,
    public unloadingCustomerHash?: string,
    public unloadingCustomerBusinessName?: string,
    public unloadingPlace?: string,
    public unloadingCustomerNif?: string,
    public saleOfferBearingVisibilities?: SaleOfferBearingVisibility[]

  ) { }

  clone() {
    return new SaleOfferBearing(
      this.hash,
      this.saleOfferHash,
      this.bearingDate,
      this.observations,
      this.loadingCustomerHash,
      this.loadingCustomerBusinessName,
      this.loadingCustomerNif,
      this.loadingPlace,
      this.unloadingCustomerHash,
      this.unloadingCustomerBusinessName,
      this.unloadingPlace,
      this.unloadingCustomerNif,
      this.saleOfferBearingVisibilities
    );
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/ubaristi-app-test/workspace/src/app/core/models/sale-offer-bearing.ts